<template>
    <div id="RefundGoodsLogistics">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click.native="goBack()"/>
            </div>
            <div slot="title">{{langText.title}}</div>
        </nav-bar>
        <div class="apply-content">
            <ul class="content">
                <li class="content-item" style="border-radius: 10px;">
                    <div style="width: 100%; height: 5px; border-radius: 20px;"></div>
                    <div class="sale-info" style="margin: 10px; line-height: 20px;">
                        <span class="sale-info-left" style="font-size: 15px;">&nbsp;{{langText.returnGoods}}</span>
                    </div>
                    <van-card v-for="(goodsItem, goodsIndex) of goodsItemArray"
                              :num="goodsItem.productQuantity"
                              :price="goodsItem.productPrice"
                              :desc="goodsItem.productAttr"
                              :title="goodsItem.productName"
                              :thumb="goodsItem.productPic">
                    </van-card>
                    <van-cell :title="langText.total">
                        <span style="color: red;">￥{{sumprice}}</span>
                    </van-cell>
                    <div style="width: 100%; height: 10px;"></div>
                </li>
            </ul>

            <br/>
            <van-form @submit="onSubmit" >
                <van-field style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
                        v-model="fromLogistics.returnLogisticsNumber"
                        name="returnLogisticsNumber"
                        :label="langText.returnLogisticsNumber"
                        :placeholder="langText.returnLogisticsNumber"
                        :rules="[{ required: true, message: langText.returnLogisticsNumberHit }]"
                />
<!--                <van-field v-model="fromLogistics.returnLogisticsName"-->
<!--                           name="returnLogisticsNumber"-->
<!--                           :label="langText.returnLogisticsName"-->
<!--                           :placeholder="langText.returnLogisticsName"-->
<!--                           :rules="[{ required: true, message: langText.returnLogisticsNameHit }]"/>-->
                <van-field
                        readonly
                        clickable
                        :label="langText.returnExpressCompany"
                        :value="returnLogisticsNumberShow"
                        :placeholder="langText.chooseReturnDeliveryCompany"
                        @click="showPicker = true"
                />
                <van-popup v-model="showPicker" round position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="companyOptions"
                            :cancel-button-text = "commonText.cancel"
                            :confirm-button-text = "commonText.confirm"
                            @cancel="showPicker = false"
                            @confirm="onConfirm"
                    />
                </van-popup>
                <van-cell :title="langText.hit"></van-cell>
                <div style="margin: 16px 0;">
                    <van-button block round type="info" native-type="submit" color="#FF6347">
                        {{langText.submithint}}
                    </van-button>
                </div>
            </van-form>
        </div>


    </div>
</template>

<script>
    import NavBar from "@/components/common/navbar/NavBar";
    import {Icon, List, PullRefresh, Card, Button, Toast, Divider, Steps, Step, Form, Field, Cell, Picker,Popup } from 'vant';
    import { setLogisticsNumber } from '@/network/refund/refund';
    import { getOrderDetail } from '@/network/order/order';

    import { langPackage } from "@/config/lang/refundGoodsLogisticsLang";
    import { selectLang } from "@/config/setLanguage"

    export default {
        name: "RefundGoodsLogistics",
        components: {
            NavBar: NavBar,
            [Icon.name]: Icon,
            [Divider.name]: Divider,
            [Steps.name]: Steps,
            [Step.name]: Step,
            [Form.name]: Form,
            [Field.name]: Field,
            [Button.name]:Button,
            [Cell.name]: Cell,
            [Card.name]: Card,
            [Toast.name]:Toast,
            [Picker.name]:Picker,
            [Popup.name]:Popup,
        },
        data(){
          return {
              goodsItem:{
                  productQuantity: "",
                  productPrice: "",
                  productAttr: "",
                  productName: "",
                  productPic: "",
                  productId:""
              },
              goodsItemArray:[],
              sumprice:0,
              langText:{},
              commonText:{},
              lang:"cn",
              fromLogistics:{
                  id:"",
                  returnLogisticsNumber:"",
                  returnLogisticsName:"",
              },
              //显示退货物流 文字信息
              returnLogisticsNumberShow:"",
              //退货快递
              companyOptions: ["圆通快递","韵达快递"],
              show:false,
              showPicker:false,
          }
        },
        methods:{
            goBack() {
                this.$router.back(-1);
            },
            //选择快递
            onConfirm(value) {
                this.returnLogisticsNumberShow = value;
                if (value == "YTO"){
                    value = "圆通快递"
                }

                if (value == "YunDa"){
                    value = "韵达快递"
                }
                this.fromLogistics.returnLogisticsName = value;
                this.showPicker = false;
            },
            getProductDesc(productArr) {
                let str = '';
                if (productArr == null) {
                    return str
                }
                let arr = JSON.parse(productArr);
                for (let $i = 0; $i < arr.length; $i++) {
                    str += arr[$i]['key'] + ':' + arr[$i]['value']
                    if ($i != arr.length - 1) {
                        str += ' / ';
                    }
                }
                return str;
            },
            onSubmit(){
                this.fromLogistics.id = this.$route.query.id;
                //判断快递公司是否为空
                if (this.fromLogistics.returnLogisticsName == ""){
                    Toast.fail("退货快递公司为空！");
                    return false;
                }
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                });
                setTimeout(() => {
                    //提交退货订单
                    setLogisticsNumber(this.fromLogistics).then(res =>{
                        if (res.code == 200){
                            Toast.success("修改成功！");
                            this.$router.push({path: '/order/afterSalesServiceList'})
                        }
                    },error => {
                            Toast.fail("修改失败！")
                    })
                }, 1000);
            }
        },
        created() {

            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
                //提前转化 物流的语言包
                this.companyOptions = [this.langText.YTO, this.langText.YunDa]
            });

            //获取订单信息

            getOrderDetail(this.$route.query.id).then(res => {
                res.data.orderItemList.forEach(res => {
                    this.goodsItem = {};
                    this.goodsItem.productQuantity = res.productQuantity;
                    this.goodsItem.productPrice = res.productPrice;
                    this.goodsItem.productAttr = this.getProductDesc(res.productAttr);
                    this.goodsItem.productName = res.productName;
                    this.goodsItem.productPic = res.productPic;
                    this.goodsItemArray.push(this.goodsItem);
                    this.sumprice += (res.productPrice * res.productQuantity);
                });
            })//end

        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    .apply-content {
        margin-top: 46px;
        padding: 10px 10px;
    }

    /*购物卡片的css属性*/
    .content-item {
        background-color: #ffffff;
        margin-top: 10px;
    }

</style>
